(function () {
    "use strict";

    // @ngInject
    function WorkspaceFeedControllerCtor($scope, $stateParams, $injector, $window, $translate, $timeout, $sce, _, JsSlicklightboxService,
                                         InitialAppLoadParamsService,WorkspacesManager, UsersManager, FeedService,
                                         AnalyticsService, Enums, CompanyService, ModalService,
                                         EventsManager, WebsocketHelperService, AbTestService, PvlService, $location, RepositoryService, OnboardingBotManager, UiPersistenceService, WorkspaceService,UIUtils, MemberReferralsManager, ngToast, DeviceService,
                                         PopupMessageService, FacebookPixelTrackingService) {

        this.constructor.$super.call(this, $scope, $injector);
        this.__objectType = 'WorkspaceFeedController';

        this.$scope = $scope;
        this.DeviceService = DeviceService;
        this.$timeout = $timeout;
        this.InitialAppLoadParamsService = InitialAppLoadParamsService;
        this.AnalyticsService = AnalyticsService;
        this.WorkspacesManager = WorkspacesManager;
        this.MemberReferralsManager = MemberReferralsManager;
        this.ngToast = ngToast;
        this.CompanyService = CompanyService;
        this.AbTestService = AbTestService;
        this.Enums = Enums;
        this.FeedService = FeedService;
        this.WorkspaceService = WorkspaceService;
        this.PvlService = PvlService;
        this.UiPersistenceService = UiPersistenceService;
        this.EventsManager = EventsManager;
        this.WebsocketHelperService = WebsocketHelperService;
        this.$sce = $sce;
        this.$translate = $translate;
        this.$stateParams = $stateParams;
        this.$window = $window;
        this.$location = $location;
        this.OnboardingBotManager = OnboardingBotManager;
        this.PopupMessageService = PopupMessageService;
        this.UIUtils = UIUtils;
        this.ModalService = ModalService;
        this._ = _;
        this.JsSlicklightboxService = JsSlicklightboxService;
        this.FacebookPixelTrackingService = FacebookPixelTrackingService;
        this.galleryInitialized = false;
        this.howItLooksImages = [
            "//res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1524037769/empty_states/how-it-works/activity_image_01.png",
            "//res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1524046387/empty_states/how-it-works/activity_image_02.png",
            "//res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1523892464/empty_states/how-it-works/activity_image_03.png",
            "//res.cloudinary.com/honeybook/image/upload/dpr_auto,q_auto/v1523892466/empty_states/how-it-works/activity_image_04.png"
        ];

        this.workspaceId = $stateParams.workspace_id;
        this.eventId = $stateParams.event_id;
        this.toggleCreateFileOptions = {scroll: true, delay: 400};
        this.lightboxContainer = "#how-it-looks-feed";
        this.emptyStatePrimaryCtaAnalyticsData = {
            eventName : this.AnalyticsService.analytics_events.action,
            data: {
                page: 'workspace_feed',
                unique: 'empty_state_primary_cta'
            }
        };
        this.emptyStateSecondaryCtaAnalyticsData = {
            eventName : this.AnalyticsService.analytics_events.action,
            data: {
                page: 'workspace_feed',
                unique: 'empty_state_secondary_cta'
            }
        };

        if (this.isCameFromCoronaDashboard()) {
            // corona track page
            AnalyticsService.trackPageView(this, 'workspace feed corona dashboard');
        } else {
            AnalyticsService.trackPageView(this, 'workspace feed');
        }

        RepositoryService.persistentPut('event:' + this.eventId, {tabToOpen: Enums.workspaceTabTypes.feed, latestWsId: this.workspaceId});

        this.cachedFeedItemsAmount = 0;

        this.focusedAfterFeedUpdate = true;
        this.ItemTypes = Enums.FeedItemTypes;

        this.currUser = UsersManager.getCurrUser();
        this.currUserId = this.currUser._id;
        this.isVendor = this.currUser.isVendor();
        this.feedUsers = {};

        this.isVendorAsClient = false;
        if(this.isVendor &&
            this.currUser.workspace_user_data &&
            this.currUser.workspace_user_data.workspace_role === 'host') {
            this.isVendorAsClient = true;
        }

        this.isViewOnlyMode = false;

        this.event = this.EventsManager.getEvent(this.eventId);

        this.workspace = WorkspacesManager.getWorkspace(this.workspaceId, false, false);
        this.register(this.workspace, 'success', this.gotWorkspace);
        this.registerOnce(this.workspace, 'success', this.firstClientBotInit);

        FeedService.registerFeed(this.workspace.feed, null);
        this.gotItems = this.workspace.feed && this.workspace.feed.hasItems();
        this.isBooked = null;

        this._hasConflict = null;
        this.conflicts =  null;

        this.lastRequestedPVL = null;
        this.showPvlClientRequest = false;
        this.pendingPvlRequestViewModel = {};
        this.pvlRequestDismissOptions = this.PvlService.getPvlRequestDismissOptions();

        this.didCheckForUrlAction = false;
        this.lastMessageSubject = null;

        this.firstInquiryPvl = false;

        this.createReferral = false;

        this.messageEditorConfig = {
            showSharePreferredVendors: this.isVendor,
            isAlternateVendorRecommendations: false
        };

        if (this.currUser.isClient()) {
            this.FacebookPixelTrackingService.trackCustom('ClientViewWorkspaceFeed');
        }


        // this func is passed and triggered by the feed message editor
        this.sendMessageFunc = function(workspcae, messageBody, attachedFiles, pvlData, subject, feedToReplyId, replyMode, scheduledSendDate) {

            // analytics
            var params = { workspace_id: this.workspaceId, reply_mode: replyMode, scheduled_email: !!scheduledSendDate};
            if(this.firstInquiryPvl) {
                params["first_inquiry_pvl"] = true;
            }
            if(this.createReferral) {
                params = angular.extend({
                    create_referral: true,
                    atws_user_id: this.referralBannerData.member_to_refer._id,
                    atws_user_email: this.referralBannerData.member_to_refer.email,
                    referral_campaign: this.referralBannerData.referral_campaign.name,
                    referral_link: this.referralBannerData.referral_link
                }, params);
            }
            AnalyticsService.track(this, AnalyticsService.analytics_events.send_workspace_feed_message, params);
            // pvl analytics - only vendors daa!!!
            if(this.isVendor && pvlData && pvlData.pvl_id) {
                this.PvlService.sendPvlSentAnalytics(pvlData, { workspace_id: this.workspaceId }, this);
            }

            // send ws message
            return WorkspacesManager.sendWorkspaceMessage(workspcae, messageBody, attachedFiles, pvlData, subject, feedToReplyId, scheduledSendDate).then(
                function success () {
                    this.afterWorkspaceMessageSent(workspcae, messageBody, attachedFiles, pvlData);

                    var shouldCollpaseEditorAfterSent = true;

                    if(this.createReferral) {
                        this.createMemberReferral();
                    }
                    this.lastMessageSubject = subject;

                    return shouldCollpaseEditorAfterSent;
                }.bind(this))
                .catch(function fail(res) {
                    if (res && res.data && res.data.error_message) {
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, res.data.error_message);
                    } else {
                        this.PopupMessageService.showAlert(this.PopupMessageService.severityTypes.error, 'ERRORS.SERVER_API._UNKNOWN_');
                    }
                }.bind(this))
                .finally(function onFinally() {
                    if(this.referralBannerData) {
                        this.referralBannerData.show_referral_banner = false;
                    }
                    this.createReferral = false;
                }.bind(this));
        }.bind(this);

        // load feed for workspace
        this.loadFeedForTheFirstTime();

        this.initFeedUsers();

        this.referralSuggestionsBlacklist = UiPersistenceService.getUiPersistence(UiPersistenceService.keys.referralSuggestionsBlacklist,
            {userEmails: []});

        // Check where the user came from
        if(!this.currUser.isActivated() && this.$stateParams.origin && this.$stateParams.origin === "email") {
            this.firstInquiryPvl = true;
            var ph = $translate.instant('COMMON_FEED_COMPONENTS.MESSAGE_EDITOR._PVL_INQUIRY_PLACEHOLDER_');
            this.setFeedEditorPlaceholder(ph);
        }

        // clean up
        $scope.$on('$destroy', function () {
            FeedService.unregisterFeed();
            this.unregister(this.workspace, 'success');
            WebsocketHelperService.unregisterFromRoom(this.workspaceFeedId);

            // clear search params if they existed so they won't stay in the url
            this.InitialAppLoadParamsService.removeParams(['action', 'source', 'action_data']);
        }.bind(this));

    }

    Controllers.WorkspaceFeedController = Class(Controllers.BaseController, {

        constructor: WorkspaceFeedControllerCtor,

        createMemberReferral: function createMemberReferral() {
            var params = {
                source: 'workspace',
                atws_user_id: this.referralBannerData.member_to_refer._id,
                atws_user_email: this.referralBannerData.member_to_refer.email,
                referral_campaign: this.referralBannerData.referral_campaign.name,
                referral_link: this.referralBannerData.referral_link
            };

            this.AnalyticsService.track(this, this.AnalyticsService.analytics_events.referral_link_shared, params);

            var referral = this.MemberReferralsManager.createReferral(this.currUser.email, this.referralBannerData.member_to_refer.email, 'workspace', 'invited');

            this.register(referral, 'success', function onSuccess() {
                this.AnalyticsService.trackSuccess(this, this.AnalyticsService.analytics_events.referral_link_shared, params);
            }.bind(this));

            this.register(referral, 'error', function onError(resp) {
                this.AnalyticsService.trackError(this, this.AnalyticsService.analytics_events.referral_link_shared, resp, params);
            }.bind(this));
        },

        firstClientBotInit: function firstClientBotInit() {
            this.onboardingBotActive = false;
            this.lastOnboardingBotState = "";
            this.hasOnboardingBotAction = false;
            this.doingBotAction = false;
            this.reloadClientBotTooltip = false;
            this._animateClientBotTooltip();
        },

        initClientBot: function initClientBot() {
            this.onboardingBotActive = this.OnboardingBotManager.isOnboardingBotActiveOnWS(this.workspace);

            if (this.onboardingBotActive && this.workspace.onboarding_bot_state && this.lastOnboardingBotState !== this.workspace.onboarding_bot_state) {
                this.lastOnboardingBotState = this.workspace.onboarding_bot_state;
                this.onboardingBotAction = this.OnboardingBotManager.getActionData(this.workspace.onboarding_bot_actions ? this.workspace.onboarding_bot_actions[0] : "");
                this.hasOnboardingBotAction = this.OnboardingBotManager.hasOnboardingBotAction(this.workspace);
                this.shouldSeeClientBotTooltip = true;
            }
        },

        openClientBotRecapModal: function openClientBotRecapModal() {
            this.ModalService.openClientBotRecapModal();
        },

        trackBotAnalytics: function trackBotAnalytics(source) {
            this.AnalyticsService.trackClick(this, this.AnalyticsService.analytics_events.onboarding_bot_cta, {
                bot_action: this.onboardingBotAction.key,
                selected_option: source
            });
        },

        onboardingBotCTA: function onboardingBotCTA() {
            this.trackBotAnalytics('next');
            this.onboardingBotDoAction();
        },

        openVideoModalCTA: function openVideoModalCTA(modalContentType) {
            this.trackBotAnalytics('learn_more');
            this.ModalService.openVideoCarouselModal(modalContentType);
        },

        isCameFromCoronaDashboard: function isCameFromCoronaDashboard() {
            return (Boolean(this.$state.previous) &&  Boolean(this.$state.previous.route) && (this.$state.previous.route.url === 'coronavirus-updates') && Boolean(this.$stateParams.template_id))
        },

        onboardingBotDoAction: function () {
            if (this.workspace.workspace_pipeline_data) {
                var currStage = this.workspace.workspace_pipeline_data.current_stage.stage_id;
            }
            this.doingBotAction = true;
            this.doingBotActionDone = false;

            if ('whats_next' === this.workspace.onboarding_bot_actions[0]) {
                this.$timeout(function() {
                    this.doingBotAction = false;
                    this._animateClientBotTooltip();
                    this.shouldSeeClientBotTooltip = false;
                    this.openClientBotRecapModal();
                }.bind(this), 500);
            } else {
                this.OnboardingBotManager.doAction(this.workspace, this.onboardingBotAction.key).then(function success() {
                    if (currStage && this.workspace.workspace_pipeline_data &&
                        this.workspace.workspace_pipeline_data.current_stage.stage_id !== currStage) {
                        this.WorkspacesManager.onWorkspaceStageUpdated(this.workspace);
                    }
                }.bind(this)).catch(function error() {
                    //
                }.bind(this)).finally(function botActionFinally() {
                    this.doingBotAction = false;
                    this._animateClientBotTooltip();
                }.bind(this));
            }
        },

        _animateClientBotTooltip: function _animateClientBotTooltip() {
            this.reloadClientBotTooltip = true;
            this.$timeout(function() {
                this.reloadClientBotTooltip = false;
            }.bind(this), 1000);
        },

        gotWorkspace: function gotWorkspace() {

            this.workspaceFeedId = this.workspace.feed._id ? this.workspace.feed._id : null;
            this.isViewOnlyMode = this.workspace.isViewOnlyMode();
            this.isBooked = this.workspace.isBooked();

            // update pvl pending request
            this.updatePendingPvlRequestForWorkspace();
            this.calculateIfToShowPvlClientRequest();

            if(!this.didCheckForUrlAction) {
                this.checkUrlAction();
            }

            if(!this.referralBannerData && this.isOwnerMode() && this.currUser.companyHasSubscription()) {
                this.getReferralBannerData();
            }

            this.initFeedUsers();
            this.initClientBot();
            this.getLastMessageForReply();
        },

        initFeedUsers: function initFeedUsers() {
            this.feedUsers = {};
            angular.forEach(this.workspace.members, function(member) {
                this.feedUsers[member._id] = member;
            }.bind(this));
            this.deletedUsers = {};
            angular.forEach(this.workspace.deleted_members, function(member) {
                this.deletedUsers[member._id] = member;
            }.bind(this));
        },

        getReferralBannerData: function getReferralBannerData() {
            this.WorkspacesManager.getReferralBannerData(this.workspaceId)
                .then(function onSuccess(res) {
                    this.referralBannerData = res.data;
                    if(this.shouldShowReferralBanner()) {
                        var params =  {
                            atws_user_id: this.referralBannerData.member_to_refer._id,
                            atws_user_email: this.referralBannerData.member_to_refer.email,
                            referral_campaign: this.referralBannerData.referral_campaign.name,
                            referral_link: this.referralBannerData.referral_link,
                            state: 'confirmation',
                            is_mobile: this.DeviceService.checkIfMobileSize()
                        };
                        this.AnalyticsService.trackLoad(this, this.AnalyticsService.analytics_events.referral_banner, params);
                    }
                }.bind(this));
        },

        getFeedForWorkspace: function getFeedForWorkspace() {
            return this.WorkspacesManager.getFeedForWorkspace(this.workspace, this.workspaceId)
                .then(this.markCurrentFeedItemsAsSeen.bind(this));
        },

        markCurrentFeedItemsAsSeen: function markCurrentFeedItemsAsSeen() {

            if (this.currUser.isAdminLogin()) {
                return;
            }

            var feedItems = this.workspace.feed.feed_items;
            var itemsToMark = feedItems.filter(function(item) {

                var usersExistsInFeedTracking = this._.findIndex(item.feed_tracking, function(ft) {
                    return ft.to_user_id === this.currUserId && ft.source === 'feed';
                }.bind(this)) !== -1;

                return item.sender_id && item.sender_id !== this.currUserId && !usersExistsInFeedTracking;
            }.bind(this));
            if (itemsToMark.length) {
                return this.WorkspacesManager.markFeedItemsAsSeen(this.workspace._id, itemsToMark);
            }
        },

        calculateIfToShowPvlClientRequest: function calculateIfToShowPvlClientRequest() {
            var disable_client_pvl_requests = false;
            if (this.workspace.workspace_files && this.workspace.workspace_files.length > 0) {
                disable_client_pvl_requests = this.workspace.workspace_files[0].owner.disable_client_pvl_requests || false;
            }

            this.showPvlClientRequest =
            !this.PvlService.hasAnyPvlOnWorkspace(this.workspace) &&
            !this.isVendor &&
            this.isBooked &&
            !this.workspace.dismissed_feed_pvl_request &&
            !disable_client_pvl_requests;
        },

        loadFeedForTheFirstTime: function() {
            this.getFeedForWorkspace().then(
                function success() {

                    // mark as loaded
                    this.gotItems = true;

                    // update cached items count
                    var feedItems = this.workspace.feed.feed_items;
                    this.cachedFeedItemsAmount = !!feedItems ? feedItems.length : 0;

                    // register for feed updates trigger
                    this.WebsocketHelperService.registerToRoom(this.workspaceFeedId, this.refreshFeed.bind(this));
                }.bind(this)
            );
        },

        refreshFeed: function refreshFeed() {
            this.getFeedForWorkspace().then(
                function success() {
                    var newestSentBySelf, feedAmountChanged;
                    var feedItems = this.workspace.feed.feed_items;

                    // updated feed items length
                    var itemsLength = !!feedItems ? feedItems.length : 0;

                    // check for updates
                    if (itemsLength > 0) {
                        newestSentBySelf  = feedItems[itemsLength - 1].sender_id === this.currUserId;
                        feedAmountChanged = this.cachedFeedItemsAmount !== itemsLength;
                    }

                    if (feedAmountChanged && !newestSentBySelf) {
                        if (!document.hasFocus()) {
                            // todo: ios is onpageshow not onblur?

                            // mark
                            this.focusedAfterFeedUpdate = false;

                            // mark where to show the new feed message separator
                            this.oldestNewMessageIndex = itemsLength - this.cachedFeedItemsAmount - 1;

                            // update cached items count
                            this.cachedFeedItemsAmount = itemsLength;

                            // register once on focus to show the new feed items
                            this.$window.onfocus = function() {
                                this.focusedAfterFeedUpdate = true;
                                this.$window.onfocus = null;
                            }.bind(this);
                        }

                    }
                    // Send last feed message subject on feed update
                    this.getLastMessageForReply();
                    this.$scope.$broadcast('feedRefreshed');
                }.bind(this)
            );
        },

        showConflictNotification: function showConflictNotification() {
            return (this.canShow() && this.hasConflict());
        },

        canShow: function canShow() {
            return (!this.event.hide_conflict_pvl_action);
        },

        hasConflict: function hasConflict() {
            if (typeof(this._hasConflict) === "boolean") {
                return this._hasConflict;
            }
            if (this.event._id && this.event.event_date) {
                this._hasConflict = false; //temp answer till server returns answer
                this.EventsManager.getConflictingEvents(this.event).then(
                    function success(resp) {
                        if (resp.data.has_conflict) {
                            this._hasConflict = true;
                            this.conflicts = resp.data;
                        } else {
                            this._hasConflict = false;
                        }
                        this.messageEditorConfig.isAlternateVendorRecommendations = (this._hasConflict && this.canShow());
                    }.bind(this),
                    function error() {
                    }
                );
            }
            else {
                return false;
            }
        },

        respondToClientPvlRequest: function respondToClientPvlRequest() {
            // open pvl edit
            this.openEditPreferredVendorsList('request_in_workspace_feed');
        },

        updatePendingPvlRequestForWorkspace: function updatePendingPvlRequestForWorkspace() {

            this.lastRequestedPVL = this.getPendingPvlRequestForWorkspace();

            this.pendingPvlRequestViewModel = {
                hasPendingPvlRequest: !!this.lastRequestedPVL,
                pendingPvlRequestClientName: this.PvlService.getPvlRequesterName(this.workspace, this.lastRequestedPVL),
                pendingPvlRequestVendorTypes: this.PvlService.getRequestedVendorTypesStringFromPvl(this.lastRequestedPVL)
            };

            this.hasAnyPvlRequest = this.PvlService.hasAnyPvlOnWorkspace(this.workspace);
        },

        cleanPendingPvlRequestForWorkspace: function cleanPendingPvlRequestForWorkspace() {

            this.lastRequestedPVL = null;

            this.pendingPvlRequestViewModel = {
                hasPendingPvlRequest: false,
                pendingPvlRequestClientName: null,
                pendingPvlRequestVendorTypes: ""
            };

        },

        getPendingPvlRequestForWorkspace: function getPendingPvlRequestForWorkspace() {
            return this.PvlService.getPendingPvlRequestForWorkspace(this.workspace, this.currUserId);
        },

        onDismissPvlRequest: function onDismissPvlRequest(option) {
            this.WorkspacesManager.dismissRequestsForPvl(this.workspace, this.lastRequestedPVL._id, option);
        },

        openEditPreferredVendorsList: function openEditPreferredVendorsList(source) {

            // Analytics
            this.AnalyticsService.track(this, "create preferred vendors list", {source: source});

            // pass pvl request id
            //var pvl_id = this.lastRequestedPVL ? this.lastRequestedPVL._id : undefined;

            // call the create async style
            if (!this.FeedService.createPreferredVendorList(this.lastRequestedPVL)) {
                // feed editor not yet registered. call again after registration.
                this.register(this.workspace.feed, "registerFeedEditor", function() {
                    this.FeedService.createPreferredVendorList(this.lastRequestedPVL);
                }.bind(this));
            }
        },

        afterWorkspaceMessageSent: function afterWorkspaceMessageSent(workspcae, messageBody, attachedFiles, pvlData) {

            // if PVL was sent hide pvl conflict action
            if(pvlData.pvl_id) {
                this.EventsManager.setPvlConflictView(this.event, true);
                this.cleanPendingPvlRequestForWorkspace();
            }
        },

        checkUrlAction: function checkUrlAction() {

            if(this.didCheckForUrlAction) {
                return;
            }

            var action = this.$stateParams.action;
            if(!action) {
                this.didCheckForUrlAction = true;
                return;
            }

            if(action === "open_pvl" && this.$stateParams.action_data) {
                this.didCheckForUrlAction = true;
                this.PvlService.showPreferredVendorList(this.$stateParams.action_data, this.eventId);
            } else if (action === "create_pvl" && this.lastRequestedPVL) {
                this.didCheckForUrlAction = true;
                this.openEditPreferredVendorsList(this.$stateParams.source || 'url_params');
            }
        },

        // lightbox test
        onLightboxShown: function onLightboxShown(event){
            if (event.container === this.lightboxContainer) {
                this.AnalyticsService.track(this, 'empty_state--how_it_looks',{page: 'workspace_feed', action: 'opened'});
            }
        },

        onLightboxHidden: function onLightboxHidden(event){
            if (event.container === this.lightboxContainer) {
                this.AnalyticsService.track(this, 'empty_state--how_it_looks',{stage: 'workspace_feed', action: 'closed'});
            }
        },

        onLightboxImageChanged: function onLightboxImageChanged(event){
            if (event.container === this.lightboxContainer) {
                this.AnalyticsService.track(this, 'empty_state--how_it_looks',{stage: 'workspace_feed', action: 'image_changed'});
            }

        },

        seeHowItLooks: function seeHowItLooks() {

            if (!this.galleryInitialized){
                this.JsSlicklightboxService.init(this.howItLooksImages, this.lightboxContainer);
                this.JsSlicklightboxService.on(this.JsSlicklightboxService.LIGHTBOX_HIDDEN, this.onLightboxHidden.bind(this));
                this.JsSlicklightboxService.on(this.JsSlicklightboxService.LIGHTBOX_SHOWN, this.onLightboxShown.bind(this));
                this.JsSlicklightboxService.on(this.JsSlicklightboxService.LIGHTBOX_IMAGE_CHANGE, this.onLightboxImageChanged.bind(this));
                this.galleryInitialized = true;
            }
            this.JsSlicklightboxService.show();
        },

        setFeedEditorPlaceholder: function setFeedEditorPlaceholder(text) {

            if (!this.FeedService.setFeedEditorPlaceholder(text)) {
                // feed editor not yet registered. call again after registration.
                this.register(this.workspace.feed, "registerFeedEditor", function() {
                    this.FeedService.setFeedEditorPlaceholder(text);
                }.bind(this));
            }
        },

        showBulkBanner: function showBulkBanner(item) {
            return item.data.is_bulk_email && item.sender_id === this.currUserId;
        },

        showItem: function showItem(item) {
            var isSystemGenerated = item.isSystemGenerated() || item.isEmailType(this.Enums.EmailTypes.payment_reminder);
            return !isSystemGenerated || this.workspace.feed.show_system_generated_items;
        },

        isOwnerMode: function isOwnerMode() {
            return this.currUser.company && this.currUser.company._id === this.workspace.creator.company_id;
        },

        referralBannerMessage: function referralBannerMessage() {
            return this.$translate.instant('WORKSPACE.FEED.REFERRAL_IN_WS._REFERRAL_IN_WS_BANNER_MESSAGE_', {user_first_name: this.UIUtils.sanitize(this.referralBannerData.member_to_refer.first_name), commission_amount: this.referralBannerData.referral_campaign.commission_amount});
        },

        onDismissReferralBannerExplanation: function onDismissReferralBannerExplanation() {
            this.showReferralBannerExplanation = false;
            var atwsUser = this.referralBannerData.member_to_refer;
            this.WorkspaceService.triggerOpenFeedEditor();
            var params =  {
                atws_user_id: atwsUser._id,
                atws_user_email: atwsUser.email,
                referral_campaign: this.referralBannerData.referral_campaign.name,
                referral_link: this.referralBannerData.referral_link,
                state: 'explanation',
                is_mobile: this.DeviceService.checkIfMobileSize()
            };
            this.AnalyticsService.trackCancel(this, this.AnalyticsService.analytics_events.referral_banner, params);
        },

        onDismissReferralBanner: function onDismissReferralBanner() {
            var atwsUser = this.referralBannerData.member_to_refer;
            this.referralSuggestionsBlacklist.userEmails.push(atwsUser.email);
            this.createReferral = false;
            this.WorkspaceService.triggerAutoFeedMessage('', '');
            this.UiPersistenceService.setUiPersistence(this.UiPersistenceService.keys.referralSuggestionsBlacklist, {userEmails: this.referralSuggestionsBlacklist.userEmails});
            var params =  {
                atws_user_id: atwsUser._id,
                atws_user_email: atwsUser.email,
                referral_campaign: this.referralBannerData.referral_campaign.name,
                referral_link: this.referralBannerData.referral_link,
                state: 'confirmation',
                is_mobile: this.DeviceService.checkIfMobileSize()
            };
            this.AnalyticsService.trackCancel(this, this.AnalyticsService.analytics_events.referral_banner, params);
        },

        onAcceptReferralBanner: function onAcceptReferralBanner() {
            var subject = this.$translate.instant('WORKSPACE.FEED.REFERRAL_IN_WS._SUBJECT_');
            var htmlBody = this.$translate.instant('WORKSPACE.FEED.REFERRAL_IN_WS._HTML_BODY_',
                {user_first_name: this.UIUtils.sanitize(this.referralBannerData.member_to_refer.first_name),
                discountText: this.referralBannerData.referral_campaign.discount_amount_text,
                referralLink: this.referralBannerData.referral_link});
            this.createReferral = true;
            this.showReferralBannerExplanation = true;
            this.WorkspaceService.triggerAutoFeedMessage(subject, htmlBody);
            var params =  {
                atws_user_id: this.referralBannerData.member_to_refer._id,
                atws_user_email: this.referralBannerData.member_to_refer.email,
                referral_campaign: this.referralBannerData.referral_campaign.name,
                referral_link: this.referralBannerData.referral_link,
                state: 'confirmation',
                is_mobile: this.DeviceService.checkIfMobileSize()
            };
            this.AnalyticsService.trackConfirm(this, this.AnalyticsService.analytics_events.referral_banner, params);
        },

        shouldShowReferralBanner: function shouldShowReferralBanner() {
            var shouldShowReferralBanner = false;
            if(this.referralBannerData && this.referralBannerData.show_referral_banner) {
                var atwsUser = this.referralBannerData.member_to_refer;
                shouldShowReferralBanner =  !this._.contains(this.referralSuggestionsBlacklist.userEmails, atwsUser.email);
            }
            return shouldShowReferralBanner;
        },

        getLastMessageForReply: function getLastMessageForReply() {
            var allowedTypes = [this.ItemTypes.workspace_file_email, this.ItemTypes.workspace_message, this.ItemTypes.feed_message, this.ItemTypes.workspace_email];
            var feedItems = this.workspace.feed.feed_items;
            var itemsToMark = feedItems.filter(function(item) {
                return allowedTypes.indexOf(item.type_cd) !== -1;
            }.bind(this));

            if (itemsToMark.length) {
                itemsToMark = this._.sortBy(itemsToMark, function(item){
                    return item.origin_date ? item.origin_date : item.created_at;
                });

                this.lastMessageToReply =  itemsToMark[itemsToMark.length - 1];
            }
        }
    });
}());

